"use client";
import React from "react";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import { Button, FontIcon } from "@/app/_components";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {ShopItemsListResponse} from "@/app/_api/types/store";
import {openPaymentAsync} from "@/app/(pages)/paymentItemsAPI";
import styles from "./specialGiftPack.module.css";

interface SpecialGiftPackDialogProps extends SDialogProps {
    shopItemsSpecialData: ShopItemsListResponse;
    userId: number;
    dispatcher: any;
}

export const SpecialGiftPackDialogFC: React.FC<SpecialGiftPackDialogProps> = (props) => {
    const { fcKey, shopItemsSpecialData, userId, dispatcher } = props;


    // 随机选择一个礼包
    const randomIndex = Math.floor(Math.random() * shopItemsSpecialData.length);
    const randomGift = shopItemsSpecialData[randomIndex];

    const handleSpecialGiftPackClick = () => {
        const params = {
            userId,
            ...randomGift,
        }
        // 调起支付
        dispatcher(openPaymentAsync(params));
    }

    const onClose = () => {
        SDialogManagerFC.closeDialog(fcKey);
    }

    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Full"
            onClose={onClose}
        >
            <section className={`${styles.layer}`}></section>
            <div className={styles.icon_close} onClick={onClose}>
                <FontIcon icon="s-close" style={{ color: "#fff" }} />
            </div>
            <section className={`${styles.wrapper} h-v-center`}>
                <section className={styles.content}>
                    <h4>SPECIAL OFFER</h4>
                    <div className={styles.main}>
                        <img
                            className={styles.main_icon}
                            src="/img/ico_gift_special.webp"
                            alt="Special Gift"
                        />
                        <div style={{ marginBottom: ".1rem" }}>
                            <img
                                style={{
                                    verticalAlign: "-0.15rem",
                                }}
                                className={styles.icon_gold}
                                src="/img/ico_gc.png"
                                alt="Gold Coin"
                            />
                            <span
                                className={styles.text_num}
                                style={{
                                    fontSize: ".9rem",
                                    color: "#FAEE31",
                                }}
                            >
                                GC {randomGift.gc.toLocaleString()}
                            </span>
                        </div>
                        <div>
                            <span className={styles.text_plus}>+</span>
                            <img className={styles.icon_gold} src="/img/ico_sc.png" alt="Special Coin" />
                            <span className={styles.text_num}>SC {randomGift.sc}</span>
                        </div>
                    </div>
                    <Button
                        color="#33D24A"
                        style={{
                            color: "#fff",
                            width: "5rem",
                            height: "1.1rem",
                            fontSize: ".6rem",
                            fontWeight: 900,
                        }}
                        onClick={handleSpecialGiftPackClick}
                    >
                        Buy for ${randomGift.money}
                    </Button>
                </section>
            </section>
        </SDialogFC>
    );
};
